import {useContext} from 'react';
import type {QueryParamAdapterComponent} from 'use-query-params';
import {
    UNSAFE_DataRouterContext,
    UNSAFE_NavigationContext,
    useLocation,
    useNavigate,
} from 'react-router';

export const ReactRouterAdapter: QueryParamAdapterComponent = ({children}) => {
    const {navigator} = useContext(UNSAFE_NavigationContext);
    const navigate = useNavigate();
    const router = useContext(UNSAFE_DataRouterContext)?.router;
    const location = useLocation();
    const navigatorLocation = (navigator as {location?: typeof location})
        .location;

    return children({
        replace(nextLocation) {
            navigate(nextLocation.search || '?', {
                replace: true,
                state: nextLocation.state,
            });
        },
        push(nextLocation) {
            navigate(nextLocation.search || '?', {
                replace: false,
                state: nextLocation.state,
            });
        },
        get location() {
            return router?.state?.location ?? navigatorLocation ?? location;
        },
    });
};
